/**
 * Thin toast for server `inputRejected` messages. Should never fire
 * for honest clients — if it does, it's a bug signal.
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";

export function RejectionToast(): ReactElement | null {
  const { state } = useStore();
  if (state.rejections.length === 0) return null;
  const latest = state.rejections[state.rejections.length - 1];
  if (latest === undefined) return null;
  return (
    <div
      data-testid="rejection-toast"
      data-reason={latest.reason}
      style={{
        position: "absolute",
        bottom: 120,
        left: "50%",
        transform: "translateX(-50%)",
        padding: "6px 12px",
        background: "#5a1a1a",
        color: "#fff",
        borderRadius: 4,
        fontSize: 12,
      }}
    >
      input rejected: {latest.reason}
    </div>
  );
}
